import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'j-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
  @Input() label: string;
  @Input() control: FormControl;
  @Input() value?: boolean = true;

  constructor() { }

  ngOnInit(): void {
    this.control = this.control ?? new FormControl('');
  }
}
